import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getKeysFromTemplate, compileHandlebarTemplate, buildEntityQueryFields } from '../utils';
import { getEntityData, getEntitySchema } from '../querys';

const getKeyProps = (key, properties, dynamicProperties) => {
  if (properties && properties[key]) return properties[key];
  if (dynamicProperties && dynamicProperties[key]) return dynamicProperties[key];
  return {};
};

const validateKeysByType = (templateKeys, schema) => {
  if (!schema) return [];
  const { properties = {}, dynamicProperties = {} } = schema || {};
  return templateKeys.map(templateKey => {
    const baseKey = templateKey.split('.')[0];
    const { items, type, additionalProperties } = getKeyProps(
      baseKey,
      properties,
      dynamicProperties
    );
    if (type === 'object' && additionalProperties) {
      return baseKey;
    }
    if (items && items.type === 'object' && items.additionalProperties) {
      return baseKey;
    }
    return templateKey;
  });
};

const useStringTemplate = (parent, templates, skip = false) => {
  const { itemEntity, itemId } = parent;
  const { isPreview } = useContext(MainContext);
  const allKeys = templates.map(template => getKeysFromTemplate(template));
  const templateKeys = [...new Set(allKeys.flat())];

  const hasTemplateKeys = !!templateKeys.length;
  const shouldSkipQuerys = skip || !hasTemplateKeys || !itemId || !itemEntity;
  const {
    loading,
    data: {
      getEntitySchema: { actions: { getPublished, get } = {} } = {},
      getEntitySchema: entitySchema
    } = {}
  } = useQuery(getEntitySchema, {
    variables: {
      id: itemEntity
    },
    skip: shouldSkipQuerys
  });
  const validatedKeys = validateKeysByType(templateKeys, entitySchema);
  const actionToUse = isPreview ? get : getPublished || get;
  const entityQueryFields = buildEntityQueryFields(validatedKeys);
  const { data: { entityData = {} } = {}, loading: entityDataLoading } = useQuery(
    getEntityData(actionToUse, entityQueryFields),
    {
      variables: { id: itemId },
      skip: loading || !entitySchema || shouldSkipQuerys
    }
  );
  const isLoading = loading || entityDataLoading;

  const formatedData = { currentParent: { ...entityData } };

  const compiledTemplates = templates.map((template, i) => {
    const hasKeys = allKeys[i] && allKeys[i].length;
    if (!hasKeys) return template;
    return compileHandlebarTemplate(template, formatedData);
  });
  return { loading: isLoading, data: compiledTemplates };
};

export default useStringTemplate;
